<script>
    import ChromeWebstoreImg from "$/assets/images/chrome-store.png";
    import EdgeWebstoreImg from "$/assets/images/edge-store.png";
</script>

<div class="buttons">
    <a
        class="button"
        href="https://chrome.google.com/webstore/detail/collabwriting-shareable-n/jjefmmjicedljonbpdoeceklnhobmolo"
    >
        <img src={ChromeWebstoreImg} alt="Chrome Webstore" />
    </a>

    <a
        class="button"
        href="https://microsoftedge.microsoft.com/addons/detail/collabwriting-shareable/oaaidbemenheminahjaojcafppklekjd"
    >
        <img src={EdgeWebstoreImg} alt="Edge Add-ons Store" />
    </a>
</div>

<style>
    @import "../../main.css";

    .buttons {
        @apply reset flex flex-row flex-wrap items-center justify-center gap-x-4 p-4 !important;
    }
    .button {
        @apply reset w-40 cursor-pointer px-2 py-1 transition-all hover:scale-105 hover:shadow-md !important;
    }
</style>
